module.exports = __webpack_public_path__ + "img/bj001.74d0f2c1.png";